import { render, staticRenderFns } from "./StorefinderCollapse.vue?vue&type=template&id=09c63008"
import script from "./StorefinderCollapse.vue?vue&type=script&lang=js"
export * from "./StorefinderCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c63008')) {
      api.createRecord('09c63008', component.options)
    } else {
      api.reload('09c63008', component.options)
    }
    module.hot.accept("./StorefinderCollapse.vue?vue&type=template&id=09c63008", function () {
      api.rerender('09c63008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/storefinder/Resources/Private/Assets/Scripts/Components/StorefinderCollapse.vue"
export default component.exports